import React  from 'react';
import styled from 'styled-components';

const RequiredSpan = styled.span`
  float     : right;
  font-size : 12px;
  color     : #AAA;
  margin    : 0 10px;
`;

export const RequiredLabel = (): JSX.Element => <RequiredSpan>Required</RequiredSpan>;
